import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=966d27ea&scoped=true&"
import script from "./Workbench.vue?vue&type=script&lang=js&"
export * from "./Workbench.vue?vue&type=script&lang=js&"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=966d27ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966d27ea",
  null
  
)

export default component.exports